// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-Header----Header-module---header---2gV_n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.module.scss
// module id = 99
// module chunks = 144251824217401 267335670960996